import { inject, Injectable } from '@angular/core';
import { GoogleTagManagerService } from 'angular-google-tag-manager';

@Injectable({ providedIn: 'root' })
export class TagsService {
  gtmService = inject(GoogleTagManagerService);

  sendInteraction(actionName: string, actionParameter?: string) {
    const event = 'interaction';
    this.gtmService.pushTag({ event, actionName, ...(actionParameter && { actionParameter }) });
  }

  sendPage(pageLevel1: string, pageLevel2?: string) {
    const event = 'page';
    this.gtmService.pushTag({ event, pageLevel1, ...(pageLevel2 && { pageLevel2 }) });
  }
}
